<script lang="ts" setup>
interface Props {
  elements: string[]
  inTwoColsFrom: number
}

const props = defineProps<Props>()

function getExtrasData() {
  const amountOfElements = props.elements.length
  if (props.elements.length < props.inTwoColsFrom) {
    return {
      cols: [props.elements],
    }
  }

  const firstColAmount = Math.ceil(amountOfElements / 2)
  const cols = [
    props.elements.slice(0, firstColAmount),
    props.elements.slice(firstColAmount, amountOfElements),
  ]

  return {
    cols,
  }
}

const { cols } = getExtrasData()
</script>

<template>
  <tr v-for="(firstCol, index) in cols[0]" :key="index">
    <td>• {{ firstCol }}</td>
    <td v-if="cols[1]">
      <span v-if="cols[1][index]">• {{ cols[1][index] }}</span>
    </td>
  </tr>
</template>
